import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService, LanguageService } from '@ecp-caf/caf-common';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { FrameworkVariableService } from '../frmVariableService/framework-variable.service';

export interface I18nSettingEntity {
    i18nSetting?: any;
    languages?: any;
    currentLanCode?: string;
}

@Injectable()
export class FrmI18nSettingService {

    private variableKey = 'frm-i18nSetting';
    constructor(
        private frmVariable: FrameworkVariableService,
        private lanService: LanguageService,
        private http: HttpService
    ) {
    }

    public getSetting(): any {
        const temp = this.frmVariable.getFrmVariableByKey(this.variableKey);
        return this.deepClone(temp);
    }

    public getSetting$(): Observable<any> {
        const temp = this.frmVariable.getFrmVariableByKey(this.variableKey);
        return !temp ? this.loadSetting$() : of(this.deepClone(temp));
    }

    public loadSetting$(): Observable<any> {
        const rtfService = (window as any).gspframeworkService && (window as any).gspframeworkService.rtf;
        const entity: I18nSettingEntity = {};
        if (!!rtfService && !!rtfService.language) {
            try {
                const lanService = rtfService.language;
                lanService.i18nSetting(
                    res => {
                        entity.i18nSetting = res;
                    },
                    err => {
                        console.log(err);
                    }
                );
                lanService.allLanguages(
                    res => {
                        entity.languages = res;
                    },
                    err => {
                        console.log(err);
                    }
                );
                entity.currentLanCode = lanService.getLanguageCode();
                this.frmVariable.frameworkVariableReg(this.variableKey, entity);
                return of(entity);
            } catch (e) {
                console.log(e);
                return of(null);
            }
        } else {
            const languagesUrl = '/api/runtime/sys/v1.0/i18n/languageservice/getenabledlanguages';
            const settingUrl = '/api/runtime/sys/v1.0/i18n/i18nusersetting/setting';
            entity.currentLanCode = this.lanService.getLanguageCode();
            return this.http.get(languagesUrl).pipe(
                map(
                    (res) => entity.languages = res
                ),
                switchMap(
                    () => this.http.get(settingUrl)
                ),
                map(
                    (res) => {
                        entity.i18nSetting = res;
                        this.frmVariable.frameworkVariableReg(this.variableKey, entity);
                        return entity;
                    }
                ),
                catchError(
                    (err: HttpErrorResponse) => {
                        console.log(err);
                        return of(null);
                    }
                )
            );
        }
    }


    private deepClone(target: any): any {
        let result;
        if (typeof target === 'object') {
            if (Array.isArray(target)) {
                result = [];
                for (let i in target) {
                    result.push(this.deepClone(target[i]))
                }
            } else if (target === null) {
                result = null;
            } else if (target.constructor === RegExp) {
                result = target;
            } else {
                result = {};
                for (let i in target) {
                    result[i] = this.deepClone(target[i]);
                }
            }
        } else {
            result = target;
        }
        return result;
    }

}
